import { DeepReadonly, IEnrolmentStatus } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultIEnrolmentStatus: DeepReadonly<IEnrolmentStatus> = deepFreeze({
  travelStatusSection: {},
  accommodationStatusSection: {}
});
